import Vue from 'vue';

// Domain
import { AvailabilityToHireProductStateManager } from '../../domain/state/availability-to-hire-product-state-manager';
import AvailabilityToHireProductState from '../../domain/state/availability-to-hire-product-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class AvailabilityToHireProductVueStateManager implements
  AvailabilityToHireProductStateManager {
  private _state: AvailabilityToHireProductState = Vue.observable<AvailabilityToHireProductState>(
    new AvailabilityToHireProductState(),
  );

  private readonly observers: Observer[] = [];

  get state(): AvailabilityToHireProductState {
    return this._state;
  }

  set state(value: AvailabilityToHireProductState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<AvailabilityToHireProductState>) {
    type Keys = keyof AvailabilityToHireProductState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
